/**
 * Canonical shipment-domain enums. Values match the Postgres enum types on
 * `shipment_core` and `shipment_tracking` — changing values requires a
 * migration + backfill.
 */

export enum ShipmentStatus {
  PLANNED = 'planned',
  ASSIGNED = 'assigned',
  PICKED_UP = 'picked_up',
  IN_TRANSIT = 'in_transit',
  OUT_FOR_DELIVERY = 'out_for_delivery',
  DELIVERED = 'delivered',
  FAILED = 'failed',
  RETURNED = 'returned',
  CANCELLED = 'cancelled',
  ON_HOLD = 'on_hold',
}

export enum ShipmentType {
  PICKUP = 'pickup',
  DELIVERY = 'delivery',
  TRANSFER = 'transfer',
  RETURN = 'return',
  EXPRESS = 'express',
  SCHEDULED = 'scheduled',
}

export enum ShipmentPriority {
  LOW = 'low',
  NORMAL = 'normal',
  HIGH = 'high',
  URGENT = 'urgent',
  CRITICAL = 'critical',
}

/** Per-delivery leg status (nested on shipment metadata). */
export enum ShipmentDeliveryStatus {
  PENDING = 'pending',
  DELIVERED = 'delivered',
  FAILED = 'failed',
  CANCELLED = 'cancelled',
}

/**
 * Tracking-event taxonomy for `shipment_tracking.event_type`. Includes TR
 * government document lifecycle events (e-İrsaliye, U-ETDS, e-Fatura) since
 * Turkish carriers emit these through the same event pipeline.
 */
export enum TrackingEventType {
  CREATED = 'created',
  ASSIGNED = 'assigned',
  PICKED_UP = 'picked_up',
  IN_TRANSIT = 'in_transit',
  ARRIVED = 'arrived',
  OUT_FOR_DELIVERY = 'out_for_delivery',
  DELIVERED = 'delivered',
  FAILED_DELIVERY = 'failed_delivery',
  RETURNED = 'returned',
  EXCEPTION = 'exception',
  DELAY = 'delay',
  REROUTED = 'rerouted',
  CUSTOMS_CLEARED = 'customs_cleared',
  CUSTOMS_HOLD = 'customs_hold',
  EIRSALIYE_SUBMITTED = 'eirsaliye_submitted',
  EIRSALIYE_ACCEPTED = 'eirsaliye_accepted',
  EIRSALIYE_REJECTED = 'eirsaliye_rejected',
  UETDS_SUBMITTED = 'uetds_submitted',
  EFATURA_SUBMITTED = 'efatura_submitted',
  EFATURA_ACCEPTED = 'efatura_accepted',
  LOCATION_UPDATE = 'location_update',
}
